import { store } from "../store/index";
import {
  getRelief,
  register,
   filterListReliefs,
   getNextRelief,
   updateRelief,
   filterRelief,
   getTurnUuidRelief,
   listReliefToExport,

} from "../store/actions/ReliefActions.js";
// /**
//  * List order
//  */
export const listFilter = async (filter) => {
  const result = await store.dispatch(filterListReliefs(filter));
  if (result && result.payload && result.payload.data) {
    return result.payload.data;
  }
  return null;
};

export const registerRelief = async (values) => {
  let result = await store.dispatch(register(values));
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};




export const getReliefData = async (uuid) => {
  
  const result = await store.dispatch(getRelief( uuid ));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

export const getNextReliefData = async (nextTurnUuid) => {
  const result = await store.dispatch(getNextRelief( nextTurnUuid ));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

export const getReliefByTurnUuid = async (turnUuid) => {
  const result = await store.dispatch(getTurnUuidRelief( turnUuid ));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

export const editRelief = async (values, uuid) => {
  let result;
  result = await store.dispatch(updateRelief(values, uuid));
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};


/**
 * List Inventary
 */
export const listFilterRelief = async (filter) => {
  const result = await store.dispatch(filterRelief(filter));
  if (result && result.payload && result.payload.data) {
    return result.payload.data;
  }
  return null;
};

export const listToExport = async (filter) => {
  const result = await store.dispatch(listReliefToExport(filter));
  if (result && result.payload && result.payload.data) {
    return result.payload.data;
  }
  return null;
};